import React, { useMemo, useState } from "react";

export default function MissionPanel({ stage, items = [], filter, onFilterChange }) {
  const [localFilter, setLocalFilter] = useState("recent");
  const activeFilter = filter ?? localFilter;
  const setFilter = onFilterChange ?? setLocalFilter;

  const { pending, resolved } = useMemo(() => {
    const p = [], r = [];
    for (const it of items) {
      if (it.status === "resolved") r.push(it);
      else p.push(it);
    }
    return { pending: p, resolved: r };
  }, [items]);

  const displayed = useMemo(() => {
    if (activeFilter === "resolved") return resolved;
    if (activeFilter === "old") return [...items].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    return [...pending].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }, [items, pending, resolved, activeFilter]);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:10 }}>

      {/* ── Header ── */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:4 }}>
        <div style={{
          fontSize:11, letterSpacing:".1em", textTransform:"uppercase",
          color:"rgba(148,163,184,.8)", fontFamily:"ui-monospace,monospace", fontWeight:700,
        }}>
          Guide — Étape {stage}
        </div>
        <div style={{ fontSize:11, fontFamily:"ui-monospace,monospace" }}>
          <span style={{ color:"rgba(241,245,249,.9)", fontWeight:700 }}>{pending.length}</span>
          <span style={{ color:"rgba(148,163,184,.6)" }}> à faire · </span>
          <span style={{ color:"rgba(52,211,153,.9)", fontWeight:700 }}>{resolved.length}</span>
          <span style={{ color:"rgba(148,163,184,.6)" }}> résolus</span>
        </div>
      </div>

      {/* ── Filtres ── */}
      <div style={{ display:"flex", gap:5 }}>
        {[
          { id:"recent",   label:"Récents"  },
          { id:"resolved", label:"Résolus"  },
          { id:"old",      label:"Anciens"  },
        ].map(f => (
          <button
            key={f.id}
            type="button"
            onClick={() => setFilter(f.id)}
            style={{
              flex:1, fontSize:11, padding:"5px 8px", borderRadius:8,
              border: activeFilter === f.id
                ? "1px solid rgba(99,102,241,.5)"
                : "1px solid rgba(255,255,255,.09)",
              background: activeFilter === f.id
                ? "rgba(99,102,241,.2)"
                : "rgba(255,255,255,.03)",
              color: activeFilter === f.id
                ? "rgba(165,180,252,1)"
                : "rgba(148,163,184,.65)",
              cursor:"pointer", letterSpacing:".05em", textTransform:"uppercase",
              transition:"all .15s", fontFamily:"ui-monospace,monospace", fontWeight:700,
              textAlign:"center",
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* ── Liste ── */}
      {displayed.length === 0 ? (
        <div style={{ fontSize:12, color:"rgba(100,116,139,.65)", fontFamily:"ui-sans-serif,system-ui", padding:"4px 0" }}>
          {items.length === 0
            ? "Aucune info pour le moment."
            : activeFilter === "resolved"
            ? "Aucun élément résolu."
            : "Tout est résolu ✅"}
        </div>
      ) : (
        <ul style={{ display:"flex", flexDirection:"column", gap:5, listStyle:"none", margin:0, padding:0 }}>
          {displayed.map((it) => {
            const isResolved = it.status === "resolved";
            return (
              <li
                key={it.key}
                style={{
                  display:"flex", alignItems:"flex-start", gap:9,
                  padding:"8px 10px", borderRadius:7,
                  background: isResolved ? "rgba(52,211,153,.04)" : "rgba(255,255,255,.025)",
                  border: isResolved
                    ? "1px solid rgba(52,211,153,.15)"
                    : "1px solid rgba(255,255,255,.06)",
                }}
              >
                {/* Checkbox SVG */}
                <div style={{
                  flexShrink:0, marginTop:2,
                  width:15, height:15, borderRadius:4,
                  border: isResolved
                    ? "1.5px solid rgba(52,211,153,.7)"
                    : "1.5px solid rgba(100,116,139,.45)",
                  background: isResolved ? "rgba(52,211,153,.18)" : "transparent",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  boxShadow: isResolved ? "0 0 6px rgba(52,211,153,.2)" : "none",
                }}>
                  {isResolved && (
                    <svg width="9" height="9" viewBox="0 0 9 9">
                      <path d="M1.5 4.5L3.8 7L7.5 2" stroke="rgba(52,211,153,.95)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    </svg>
                  )}
                </div>
                <span style={{
                  fontSize:12, lineHeight:1.5,
                  color: isResolved ? "rgba(100,116,139,.5)" : "rgba(226,232,240,.88)",
                  textDecoration: isResolved ? "line-through" : "none",
                  fontFamily:"ui-sans-serif,system-ui",
                }}>
                  {it.text}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}